export const cleverTapMixin = {
  data() {
    return {};
  },
  methods: {
    $_pushCleverTapEvent(name, payload) {
      if (window.clevertap && name) {
        let eventPayload = {};
        const eventName = name;
        eventPayload = payload;
        eventPayload.app = 'Tandem';
        window.clevertap.event.push(eventName, eventPayload);
      }
    },
  },
};
